import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';
import type { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, LabelL, LabelM } from '@sorare/core/src/atoms/typography';

import type {
  PremiumPackTitle_cardPack,
  PremiumPackTitle_cardPackGroup,
} from './__generated__/index.graphql';
import { PackRotationAt } from '../../PackRotationAt';

const Header = styled(Vertical)`
  width: 100%;
`;
type Props = {
  cardPackGroup: PremiumPackTitle_cardPackGroup;
  cardPack: PremiumPackTitle_cardPack;
};

export const PremiumPackTitle = ({ cardPackGroup, cardPack }: Props) => {
  return (
    <Header gap={0.5}>
      <SBHorizontal>
        <BrandM>
          <FormattedMessage
            id="PremiumPack.title"
            defaultMessage="Elite Pack"
          />
        </BrandM>
        <LabelM color="var(--c-yellow-400)">
          <PackRotationAt cardPackGroup={cardPackGroup} />
        </LabelM>
      </SBHorizontal>
      <LabelL
        className="text-gradient-color"
        style={
          {
            '--text-gradient-color':
              'linear-gradient(315deg, #868a8a 14.64%, #e8ecee 85.36%)',
          } as CSSProperties
        }
      >
        {cardPack.competition?.displayName}
      </LabelL>
    </Header>
  );
};

PremiumPackTitle.fragments = {
  cardPackGroup: gql`
    fragment PremiumPackTitle_cardPackGroup on CardPackGroup {
      id
      ...PackRotationAt_cardPackGroup
    }
    ${PackRotationAt.fragments.cardPackGroup}
  ` as TypedDocumentNode<PremiumPackTitle_cardPackGroup>,
  cardPack: gql`
    fragment PremiumPackTitle_cardPack on CardPack {
      slug
      competition {
        slug
        displayName
      }
    }
  ` as TypedDocumentNode<PremiumPackTitle_cardPack>,
};
